module.exports = __webpack_public_path__ + "media/images/point/special-position-new-ccb7c5a7297e036051e4440f4f78c0f2.png";